export const FindParentBundleFromItem = (qrItems, item) => {
  return qrItems.find((i) => i.id === item.bundleParentId);
};
